import coachingRoutes from "./training/coaching.routes"
import quizRoutes from "./training/quiz.routes"
import surveyRoutes from "./training/survey.routes"

export default [
    ...coachingRoutes,
    ...quizRoutes,
    ...surveyRoutes
]